import React from 'react';
import styled from 'styled-components';
import { Grid, Col } from '@enso/components';
import { utils } from '@enso/components';
import theme from '../../../theme';

const RegulatoryContainer = styled.section`
  padding: 60px 24px;
  background-color: ${props => props.theme.color.backgroundWhite};

  @media ${utils.device.laptop} {
    padding: 80px 140px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const LeftColumn = styled(Column)`
  align-items: flex-start;
  text-align: left;
`;

const ImagesRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 24px;
  align-items: flex-start;
`;

const RegulatoryImage = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
  width: auto;
  flex-shrink: 0;
`;

const CondusefText = styled.div`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: #140d38;
  line-height: 1.6;
  margin-top: 16px;

  @media ${utils.device.laptop} {
    font-size: 15px;
  }
`;

const CondusefLink = styled.a`
  color: #140d38;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`;

const RegulatoryTitle = styled.h3`
  font-family: ${props => props.theme.font.title};
  font-size: 16px;
  font-weight: bold;
  color: #140d38;
  margin-bottom: 12px;
  margin-top: 16px;

  @media ${utils.device.laptop} {
    font-size: 18px;
    margin-top: 20px;
  }
`;

const MoreInfoLink = styled.span`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: #fd5e43;
  text-decoration: none;
  margin-top: 8px;
  display: inline-block;
  cursor: default;
`;

RegulatoryContainer.defaultProps = { theme };
CondusefText.defaultProps = { theme };
RegulatoryTitle.defaultProps = { theme };
MoreInfoLink.defaultProps = { theme };

const RegulatoryInfo = function() {
  return (
    <RegulatoryContainer>
      <Grid xs="column" md="row">
        <Col md="4">
          <LeftColumn>
            <RegulatoryImage
              src="/images/enso-condusef300.webp"
              alt="CONDUSEF"
              style={{ marginBottom: '24px' }}
            />
            <CondusefText>
              Teléfono de contacto de la condusef: (55) 53 400 999
              <br />
              <CondusefLink
                href="https://www.gob.mx/condusef"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.gob.mx/condusef
              </CondusefLink>
              <br />
              <br />
              El sitio de CONDUSEF es ajeno a Enso Finve, S.A.P.I de C.V.
              Institucionalizados de Fondos de Pago Electrónico.
            </CondusefText>
          </LeftColumn>
        </Col>
        <Col md="4">
          <Column>
            <RegulatoryImage
              src="/images/buro.webp"
              alt="Buró de entidades financieras"
            />
            <RegulatoryTitle>Buró de entidades financieras</RegulatoryTitle>
            <MoreInfoLink>Más información</MoreInfoLink>
          </Column>
        </Col>
        <Col md="4">
          <Column>
            <RegulatoryImage
              src="/images/hacienda-condusef-1.webp"
              alt="Unidad Especializada de Atención a Usuarios"
            />
            <RegulatoryTitle>
              Unidad Especializada de Atención a Usuarios (UNE)
            </RegulatoryTitle>
            <MoreInfoLink>Más información</MoreInfoLink>
          </Column>
        </Col>
      </Grid>
    </RegulatoryContainer>
  );
};

export default RegulatoryInfo;
